import React, { useEffect, useState } from 'react'
import { InputModal } from '../InputModal'
import './in-app-video-player.scss'

const getVideoMimeType = (url: string) => {
  const normalized = url.toLowerCase()
  if (normalized.includes('.webm')) {
    return 'video/webm'
  }
  if (normalized.includes('.ogg') || normalized.includes('.ogv')) {
    return 'video/ogg'
  }
  return 'video/mp4'
}

type InAppVideoPlayerProps = {
  videoUrl: string
  previewImageUrl?: string
  ariaLabel?: string
  testId?: string
  className?: string
}

const InAppVideoPlayer = ({
  videoUrl,
  previewImageUrl,
  ariaLabel = 'Play video',
  testId = 'in-app-video-player',
  className = '',
}: InAppVideoPlayerProps) => {
  const [showVideoModal, setShowVideoModal] = useState(false)

  useEffect(() => {
    if (showVideoModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [showVideoModal])

  if (!videoUrl?.trim()) {
    return null
  }

  const previewStyle = previewImageUrl
    ? { backgroundImage: `url("${previewImageUrl}")` }
    : undefined

  return (
    <>
      <div className={`in-app-video-player ${className}`.trim()} data-testid={testId}>
        <button
          type='button'
          className='in-app-video-player__frame-wrap in-app-video-player__trigger'
          onClick={() => setShowVideoModal(true)}
          aria-label={ariaLabel}
        >
          <div
            className={`in-app-video-player__preview${
              previewImageUrl ? '' : ' in-app-video-player__preview--fallback'
            }`}
            style={previewStyle}
          >
            {!previewImageUrl ? (
              <video
                className='in-app-video-player__preview-video'
                muted
                playsInline
                preload='metadata'
                aria-hidden='true'
              >
                <source src={videoUrl} type={getVideoMimeType(videoUrl)} />
              </video>
            ) : null}
          </div>
          <span className='in-app-video-player__play-icon' aria-hidden='true'>
            <span />
          </span>
        </button>
      </div>

      {showVideoModal ? (
        <InputModal testId={`${testId}-modal`} className='in-app-video-player__input-modal'>
          <div
            className='in-app-video-player__modal-overlay'
            onClick={() => setShowVideoModal(false)}
          >
            <div
              className='in-app-video-player__modal-content'
              onClick={(event) => event.stopPropagation()}
            >
              <button
                type='button'
                className='in-app-video-player__modal-close'
                onClick={() => setShowVideoModal(false)}
                aria-label='Close video'
              >
                ×
              </button>
              <div className='in-app-video-player__modal-frame'>
                <video controls autoPlay playsInline>
                  <source src={videoUrl} type={getVideoMimeType(videoUrl)} />
                  Your browser does not support HTML video.
                </video>
              </div>
            </div>
          </div>
        </InputModal>
      ) : null}
    </>
  )
}

export { InAppVideoPlayer }
